import { render, staticRenderFns } from "./student-admin.view.vue?vue&type=template&id=cd5b43c0&scoped=true&"
import script from "./student-admin.view.ts?vue&type=script&lang=ts&"
export * from "./student-admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./student-admin.view.scss?vue&type=style&index=0&id=cd5b43c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5b43c0",
  null
  
)

export default component.exports